import { tap } from 'rxjs';
import { AbstractControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  DestroyRef,
  Directive,
  HostBinding,
  Inject,
  inject,
  Input,
  OnInit,
  Optional,
} from '@angular/core';

import { DisplayAfterService } from './display-after.service';

@Directive({
  selector: '[issDisplayAfter]',
  standalone: true,
})
export class DisplayAfterDirective implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private alreadyMatched = false;

  public constructor(
    @Optional() @Inject(DisplayAfterService) private readonly displayAfter: DisplayAfterService | undefined,
  ) {}

  @Input({ alias: 'issDisplayAfter', required: true }) public control!: AbstractControl | readonly AbstractControl[];

  @HostBinding('style.display')
  public get display(): string | undefined {
    return this.isMatched() ? undefined : 'none';
  }

  private isMatched(): boolean {
    if (!this.alreadyMatched) {
      this.alreadyMatched = [ this.control ].flat().filter(control => control.enabled).every(control => control.valid);
    }

    return this.alreadyMatched;
  }

  public ngOnInit(): void {
    if (this.displayAfter) {
      this.displayAfter.reset$.pipe(
        tap(() => {
          this.alreadyMatched = false;
        }),
        takeUntilDestroyed(this.destroyRef),
      ).subscribe();
    }
  }
}
